(function () {
'use strict';

angular.module('exportUtils', []).factory('ExportUtils', ExportUtils);

function ExportUtils() {
  return {
    prettyExcel: (sheetData) => {
      sheetData = sheetData.map(d => {
        Object.keys(d).forEach(key => {
          // eslint-disable-next-line no-undefined
          if (d[key] === undefined) {
            d[key] = ' ';
          }
        });
        return d;
      });
      let columnNames = Object.keys(sheetData[0]);
      // eslint-disable-next-line no-undef
      let xlsx = XLSX;
      let workbook = xlsx.utils.book_new();
      let sheet = xlsx.utils.json_to_sheet(sheetData, { header: columnNames });
      const colLengths = Object.keys(sheetData[0]).map(k => k.toString().length);
      for (const d of sheetData) {
        Object.values(d).forEach((element, index) => {
          colLengths[index] = Math.max(element.toString().length, colLengths[index]);
          colLengths[index] = Math.min(colLengths[index], 100);
        });
      }
      sheet["!cols"] = colLengths.map((l) => ({ wch: l }));

      const range = xlsx.utils.decode_range(sheet['!ref']);


      for (let R = range.s.r; R <= range.e.r; ++R) {
        for (let C = range.s.c; C <= range.e.c; ++C) {
          let cell_address = { c: C, r: R };
          const cell_ref = xlsx.utils.encode_cell(cell_address);
          if (!sheet[cell_ref]) continue;

          let topRow = (R === 0);

          sheet[cell_ref].s = {
            fill: { fgColor: { rgb: topRow ? 'C6EFCE' : 'FFFFFF' } },
            font: { bold: topRow },
            border: {
              top: { style: 'thin', color: { rgb: '000000' } },
              bottom: { style: 'thin', color: { rgb: '000000' } },
              left: { style: 'thin', color: { rgb: '000000' } },
              right: { style: 'thin', color: { rgb: '000000' } }
            }
          };
        }
      }


      xlsx.utils.book_append_sheet(workbook, sheet, 'DATA');
      let output = xlsx.write(workbook, {type: 'buffer'});
      return output;
    },
  }
}
})();